module.exports = __webpack_public_path__ + "static/media/bedHalf.4acf994f.png";